<template>
  <v-container full-height
               fluid
               class="pa-0">
    <v-row class="full-height"
           no-gutters>
      <v-col cols="12"
             class="full-height">
        <v-row class="full-height"
               no-gutters>
          <!-- inicio de sidebar -->
          <v-col cols="2"
                 class="hidden-xs-only smartbell-sidebar pa-0 full-height">
          </v-col>
          <!-- fin de sidebar -->
          <!-- inicio de contenido principal -->
          <v-col cols="12" sm="10"
                 id="container-right"
                 class="full-height std-background-white-1">
            <!-- dialog -->
            <v-snackbar
                    v-model="snackbar"
                    bottom
                    right
                    color="success"
            >
              <v-progress-circular
                      size="24"
                      color="#FFFFFF"
                      :indeterminate="true"
                      width="4"
              ></v-progress-circular>
              {{ animalString }}
              <v-btn dark
                     text
                     @click="snackbar = false">
                Cerrar
              </v-btn>
            </v-snackbar>
            <div class="text-center">
              <v-dialog
                      :attach="'#container-right'"
                      v-model="dialog"
                      width="500"
              >
                <v-card>
                  <v-card-title
                          class="std-text-xl std-background-blue-2 std-text-white-1 font-weight-bold">
                    ¡Alto ahí!
                  </v-card-title>
                  <v-card-text class="mt-4 std-text-md">
                    Parece ser que <b>no cuentas con los datos suficientes</b> para comenzar a hacer <b>nuestros cálculos</b>, pero...
                    ¡No te preocupes! <b>Aún registraremos tu vaca</b>, sólo que cuando pase algún evento reproductivo <b>tendrás
                    que indicárnoslo</b> lo antes posible para poder hacer más eficiente a tu rancho.
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            style="text-transform: none"
                            class="std-text-md"
                            @click="dialog = false"
                    >
                      Entendido
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <!-- fin de dialog -->
            <!-- inicio de barra superior -->
            <v-row class="ml-sm-6 mr-sm-12 mt-sm-3 mb-sm-6 std-top-container my-2 mx-2"
                   justify="space-between"
                   no-gutters>
              <v-col cols="1" sm="2"
                     @click="back()">
                <BackButton ></BackButton>
              </v-col>
              <!-- inicio de cambiar de rancho -->
              <v-col cols="8" sm="3" offset="1">
                <ChangeRanch
                        :paddock="paddockSelected"
                        :paddocks="currentPaddocks"
                ></ChangeRanch>
              </v-col>
              <v-col sm="3"></v-col>
              <!-- fin de cambiar de rancho -->
            </v-row>
            <!-- fin de barra superior -->
            <!-- inicio de contenedor principal -->
            <v-form ref="form"
                    v-model="valid"
                    lazy-validation>
              <v-row :class="{'std-container-shadow std-border-radius' : $vuetify.breakpoint.smAndUp }"
               class="form-main-container mb-sm-6 ml-sm-6 mr-sm-12 mx-2 my-2 align-content-start justify-center"
                   style="position: relative;"
                   no-gutters>
              <!-- título del contenedor principal -->
              <v-col cols="12"
              class="hidden-xs-only std-title-card-container align-center justify-center">
                <div class="d-flex col-10 justify-center align-center pa-0">
                  <div class="std-text-lg std-text-blue-2 font-weight-bold">Alta de {{ btnAnimal }}</div>
                </div>
              </v-col>
              <!-- fin de título del contenedor principal -->

              <!-- inicio de contenedor de inputs -->
              <v-col class="order-2 order-sm-1 hidden-xs-only" cols="12" sm="9">
                <v-row no-gutters class="ml-6">
                  <!-- inicio de título de primer bloque de inputs -->
                  <v-col cols="12" class="hidden-xs-only">
                    <div class="mb-2 std-text-blue-2 font-weight-bold" style="font-size: 20px">
                      Datos generales
                    </div>
                  </v-col>
                  <!-- fin de título de primer bloque de inputs -->
                  <!-- inicio de primer bloque de inputs -->
                  <v-col cols="12" class="pa-0">
                    <v-row no-gutters>
                      <!-- inicio de campos de texto -->
                      <v-col cols="12" sm="9">
                        <v-row no-gutters justify="space-between" class="mb-6">
                          <v-col cols="6" class="d-flex flex-wrap pr-2">
                            <div class="col-12 std-text-md std-text-blue-2 pa-0">Raza del animal</div>
                            <v-autocomplete
                                    v-model="animal.breed"
                                    :items="breeds"
                                    hide-details
                                    dense
                                    flat
                                    placeholder="Holstein"
                                    outlined
                                    required
                                    :rules="breedRules"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="6" class="d-flex flex-wrap pl-2">
                            <div class="col-12 std-text-md std-text-blue-2 pa-0">Potrero</div>
                            <v-autocomplete
                                    v-model="animal.group"
                                    :items="groups"
                                    dense
                                    hide-details
                                    placeholder="Establo increíble"
                                    outlined
                                    :rules="paddockRules"
                                    required
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row no-gutters justify="space-between">
                          <v-col cols="6" class="d-flex flex-wrap pr-2">
                            <div class="col-12 std-text-md std-text-blue-2 pa-0">Identificador interno</div>
                            <v-text-field
                                    v-model="animal.idInternal"
                                    class="form-text-input"
                                    outlined
                                    dense
                                    placeholder="123"
                                    :rules="idRules">
                            </v-text-field>
                          </v-col>
                          <v-col cols="6" class="d-flex flex-wrap pl-2">
                            <div class="col-12 std-text-md std-text-blue-2 pa-0">Fecha de nacimiento</div>
                            <v-menu
                                    v-model="birthdayPicker"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                        append-icon="mdi-calendar-blank"
                                        outlined
                                        :value="formattedBirthday"
                                        dense
                                        placeholder="DD/MM/AAAA"
                                        readonly
                                        required
                                        :rules="genericRules"
                                        v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                      :key="birthdayKey"
                                      v-model="animal.birthday"
                                      :allowed-dates="awdBirthday"
                                      @input="birthdayPicker = false"
                                      locale="es-419">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-col>
                      <!-- fin de campos de texto -->
                      <v-col cols="12" sm="3">
                        <div class="hidden-xs-only col-10 offset-1 std-text-md std-text-blue-2 pa-0">
                          Tipo de animal
                        </div>
                        <v-row no-gutters class=" hidden-xs-only form-input-animal-container std-text-md"
                        align-content="space-between">
                          <!-- selector de vaca -->
                          <v-col cols="11"
                                 offset="1"
                                 class="form-animal-card-container">
                            <div class="d-flex align-center full-height form-animal-disabled px-4 std-border-radius"
                                 :class="[{'form-animal-active' : animalType === 'cow'}, {'elevation-3' : animalType === 'cow'}]"
                                 @click="setAnimalType('cow')">
                              <i class="std-icon std-cow-white-icon mr-4"
                                 :class="{'form-cow-icon-gray' : !(animalType === 'cow')}"></i>
                              <div>Vaca</div>
                            </div>
                          </v-col>
                          <!-- fin de selector de vaca -->
                          <!-- selector de vaquilla -->
                          <v-col cols="11" offset="1" class="form-animal-card-container">
                            <div class="d-flex align-center full-height form-animal-disabled px-4 std-border-radius"
                                 :class="[{'form-animal-active' : animalType === 'heifer'}, {'elevation-3' : animalType === 'heifer'}]"
                                 @click="setAnimalType('heifer')">
                              <i class="std-icon std-heifer-white-icon mr-4"
                                 :class="{'form-heifer-icon-gray' : !(animalType === 'heifer')}"></i>
                              <div>Vaquilla</div>
                            </div>
                          </v-col>
                          <!-- fin de selector de vaquilla -->
                          <!-- selector de toro -->
                          <v-col cols="11" offset="1" class="form-animal-card-container">
                            <div class="d-flex align-center full-height std-background-blue-2 form-animal-disabled px-4 std-border-radius"
                                 :class="[{'form-animal-active' : animalType === 'bull'}, {'elevation-3' : animalType === 'bull'}]"
                                 @click="setAnimalType('bull')">
                              <i class="std-icon std-bull-white-icon mr-4"
                                 :class="{'form-bull-icon-gray' : !(animalType === 'bull')}"></i>
                              <div>Toro</div>
                            </div>
                          </v-col>
                          <!-- fin de selector de toro -->
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- fin de primer bloque de inputs -->
                  <!-- titulo de segundo bloque de inputs -->
                  <v-col cols="12" class="hidden-xs-only" v-if="animalType === 'cow' || heiferReproductiveFlag">
                    <div class="mb-2 std-text-blue-2 font-weight-bold form-text-input-title">
                      Datos reproductivos
                    </div>
                  </v-col>
                  <!-- fin de titulo de segundo bloque de inputs -->
                  <!-- segundo bloque de inputs -->
                  <v-col cols="12" v-if="animalType === 'cow' || heiferReproductiveFlag">
                    <v-row no-gutters>
                      <!-- inicio de campos de texto -->
                      <v-col cols="12">
                        <v-row no-gutters>
                          <!-- input de ciclo de lactancia -->
                          <v-col cols="4" class="d-flex flex-wrap pr-2">
                            <div class="col-12 std-text-md std-text-blue-2 pa-0">Ciclo de lactancia</div>
                            <!-- input de ciclo de lactancia -->
                            <v-select
                                    v-model="animal.lactationCycle"
                                    :items="lactationCycles"
                                    dense
                                    placeholder="0"
                                    v-if="(animalType === 'heifer' && heiferReproductiveFlag) || animalType === 'cow'"
                                    outlined
                            ></v-select>
                            <!-- fin de input de ciclo de lactancia -->
                          </v-col>
                          <!-- fin de input de ciclo de lactancia -->
                          <!-- input fecha de último parto -->
                          <v-col cols="4" class="d-flex flex-wrap px-2"
                                 v-if="animalType === 'cow' && !(animal.lactationCycle === '' || animal.lactationCycle === 0)">
                            <div class="col-12 std-text-md std-text-blue-2 pa-0">Fecha de último parto</div>
                            <v-menu
                                    v-model="lastChildBirthPicker"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                        :value="formattedLastChildBirth"
                                        placeholder="DD/MM/AAAA"
                                        append-icon="mdi-calendar-blank"
                                        outlined
                                        dense
                                        readonly
                                        v-on="on">
                                </v-text-field>
                              </template>
                              <v-date-picker
                                      v-model="animal.lastChildBirth"
                                      no-title @input="lastChildBirthPicker = false"
                                      :allowed-dates="allowedLastChildBirthDates"
                                      locale="es-419"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <!-- fin de fecha de último parto -->
                          <!-- input de etapa reproductiva -->
                          <v-col cols="4" class="d-flex flex-wrap"
                                 :class="[{'px-2': animalType === 'heifer'}, {'pl-2': animalType === 'cow'}]"
                                 v-if="(animalType === 'heifer' && heiferReproductiveFlag) ||
                                 animalType === 'cow' && animal.lactationCycle !== ''">
                            <div class="col-12 std-text-md std-text-blue-2 pa-0">Etapa reproductiva</div>
                            <v-select
                                    v-model="reproductiveStage"
                                    :items="reproductiveEvents"
                                    dense
                                    placeholder="Gestante"
                                    :rules="genericRules"
                                    outlined
                            ></v-select>
                          </v-col>
                          <!-- fin de input de etapa reproductiva -->
                          <!-- input de fecha de etapa reproductiva -->
                          <v-col cols="4" class="d-flex flex-wrap"
                                 :class="[{'pl-2': animalType === 'heifer'}, {'pr-2': animalType === 'cow'}]"
                                 v-if="!(this.reproductiveStage === '' || this.reproductiveStage === 'Ninguno')">
                            <div class="col-12 std-text-md std-text-blue-2 pa-0">{{stageTitle}}</div>
                            <v-menu
                                    v-model="reproductiveStagePicker"
                                    v-if="!(this.reproductiveStage === '' || this.reproductiveStage === 'Ninguno')"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                        :value="formattedReproductiveStageDate"
                                        append-icon="mdi-calendar-blank"
                                        :rules="genericRules"
                                        outlined
                                        placeholder="DD/MM/AAAA"
                                        dense
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                      v-model="reproductiveStageDate"
                                      no-title
                                      :allowed-dates="allowedReproductiveStagesDates"
                                      @input="reproductiveStagePicker = false"
                                      locale="es-419"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <!-- fin de input de fecha de etapa reproductiva (vaquilla) -->
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- fin de segundo bloque de inputs -->
                  <!-- titulo de tercer bloque de inputs -->
                  <v-col cols="12" v-if="animalType !== 'cow'">
                    <div class="mb-2 std-text-blue-2 font-weight-bold form-text-input-title">Datos adicionales</div>
                  </v-col>
                  <!-- fin de titulo de tercer bloque de inputs -->
                  <!-- tercer bloque de inputs -->
                  <v-col cols="12">
                    <v-row no-gutters>
                      <!-- inicio de campos de texto -->
                      <v-col cols="12">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="9" v-if="animalType === 'heifer'">
                            <v-row no-gutters>
                              <v-col cols="4" class="d-flex flex-wrap pr-2">
                                <div class="col-12 std-text-md std-text-blue-2 pa-0">Vaca madre</div>
                                <!-- input vaca madre -->
                                <v-select
                                        v-model="animal.cowParent"
                                        :items="tempID"
                                        placeholder="123"
                                        dense
                                        outlined
                                ></v-select>
                                <!-- fin de input vaca madre -->
                              </v-col>
                              <v-col cols="4" class="d-flex flex-wrap px-2">
                                <div class="col-12 std-text-md std-text-blue-2 pa-0">Toro padre</div>
                                <!-- input de toro padre -->
                                <v-select
                                        v-model="animal.bullParent"
                                        :items="tempID"
                                        dense
                                        placeholder="123"
                                        outlined
                                ></v-select>
                                <!-- fin de input de toro padre -->
                              </v-col>
                              <v-col cols="4" class="d-flex flex-wrap pl-2">
                                <div class="col-12 std-text-md std-text-blue-2 pa-0">Tamaño al nacer</div>
                                <!-- input de peso al nacer -->
                                <v-text-field
                                        v-model="animal.size"
                                        dense
                                        :rules="numberRules"
                                        placeholder="360"
                                        suffix="kg."
                                        outlined
                                ></v-text-field>
                                <!-- fin de input de peso al nacer -->
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="3"
                                 v-if="animalType === 'heifer'"
                                 class="d-flex flex-wrap pl-4">
                            <div class="col-12 std-text-md std-text-blue-2 pa-0">Peso al nacer</div>
                            <!-- input de peso al nacer -->
                            <v-text-field
                                    v-model="animal.weight"
                                    dense
                                    placeholder="360"
                                    suffix="metros"
                                    outlined
                                    :rules="numberRules"
                                    required
                            ></v-text-field>
                            <!-- fin de input de peso al nacer -->
                          </v-col>
                          <v-col cols="9" >
                            <v-row no-gutters>
                              <v-col cols="6"
                                     class="d-flex flex-wrap pr-2"
                                     v-if="!heiferReproductiveFlag">
                                <div class="col-12 std-text-md std-text-blue-2 pa-0">Identificador SINIIGA</div>
                                <!-- input identificador siniiga -->
                                <v-text-field
                                        v-model="animal.idSiniiga"
                                        prefix="MX-00-AGS(01)-"
                                        v-mask="'####-####'"
                                        placeholder="0000-0000"
                                        dense
                                        outlined
                                ></v-text-field>
                                <!-- fin de input identificador siniiga -->
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- fin de tercer bloque de inputs -->
                </v-row>
              </v-col>
              <!-- fin de contenedor de inputs -->

              <!-- inicio movil de selector de animales -->
              <v-col class="pa-0 d-sm-none">
                <v-row no-gutters class="std-text-md my-3 mx-6"
                    align-content="space-between"
                    justify="center">
                  <!-- selector de vaca -->
                  <v-col cols="4" class="pr-4 form-animal-card-container">
                    <div class="d-flex align-center justify-center full-height form-animal-disabled px-0 std-border-radius"
                        :class="[{'form-animal-active' : animalType === 'cow'}, {'elevation-3' : animalType === 'cow'}]"
                        @click="setAnimalType('cow')">
                      <i class="std-icon std-cow-white-icon mr-0"
                        :class="{'form-cow-icon-gray' : !(animalType === 'cow')}"></i>
                    </div>
                  </v-col>
                  <!-- fin de selector de vaca -->
                  <!-- selector de vaquilla -->
                  <v-col cols="4" class="px-2 form-animal-card-container">
                    <div class="d-flex align-center justify-center full-height form-animal-disabled px-0 std-border-radius"
                        :class="[{'form-animal-active' : animalType === 'heifer'}, {'elevation-3' : animalType === 'heifer'}]"
                        @click="setAnimalType('heifer')">
                      <i class="std-icon std-heifer-white-icon mr-0"
                        :class="{'form-heifer-icon-gray' : !(animalType === 'heifer')}"></i>
                    </div>
                  </v-col>
                  <!-- fin de selector de vaquilla -->
                  <!-- selector de toro -->
                  <v-col cols="4" class="pl-4 form-animal-card-container">
                    <div class="d-flex align-center justify-center full-height std-background-blue-2 form-animal-disabled px-0 std-border-radius"
                        :class="[{'form-animal-active' : animalType === 'bull'}, {'elevation-3' : animalType === 'bull'}]"
                        @click="setAnimalType('bull')">
                      <i class="std-icon selector-icon-container std-bull-white-icon mr-0"
                        :class="{'form-bull-icon-gray' : !(animalType === 'bull')}"></i>
                    </div>
                  </v-col>
                  <!-- fin de selector de toro -->
                </v-row>
              </v-col>
              <!-- fin movil de selector de animales -->

              <!-- inicio de contenedor de imagen -->
              <v-col class="order-1 order-sm-2 mb-4 sm-mb-0" cols="12" sm="3">
                <v-row class="mx-6 mt-sm-16"
                       no-gutters>
                  <v-img src="https://cdn.capitalradio.es/embed/2f92537db76b292d01d5b1977a085551498560800/empty.png"
                         height="195px"
                         class="std-border-radius"
                         width="100%"
                         style="margin-bottom: 27px">

                  </v-img>
                  <v-col cols="12">
                    <v-btn class="std-btn std-blue-btn sm-mb-16"
                           block
                           height="40px">Añadir foto<v-icon right dense>mdi-image-multiple</v-icon></v-btn>
                  </v-col>
                  <v-col cols="12" v-if="heiferReproductiveFlag">
                    <div class="col-12 std-text-md std-text-blue-2 pa-0">Identificador SINIIGA</div>
                    <!-- input identificador siniiga -->
                    <v-text-field
                            v-model="animal.idSiniiga"
                            prefix="MX-00-AGS(01)-"
                            v-mask="'####-####'"
                            placeholder="0000-0000"
                            dense
                            outlined
                    ></v-text-field>
                    <!-- fin de input identificador siniiga -->
                  </v-col>
                </v-row>
              </v-col>
              <!-- fin de contenedor de imagen -->

              <!-- inicio de paneles expansivos-->
              <v-expansion-panels multiple accordion class="order-3 my-2 d-sm-none">
                <v-expansion-panel>
                    <v-expansion-panel-header class="expansion-panel-background-color">
                        <b class="smart-title-2 home-title-container-mobile">Datos Generales</b>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="expansion-panel-background-color">
                        <v-col cols="12" class="d-flex flex-wrap pa-0">
                          <v-row no-gutters justify="space-between" class="mb-6">
                            <!-- inicio raza-->
                            <v-col cols="12" class="d-flex flex-wrap py-2">
                              <div class="col-12 std-text-md std-text-blue-2 pa-0">Raza del animal</div>
                              <v-autocomplete
                                      v-model="animal.breed"
                                      :items="breeds"
                                      hide-details
                                      dense
                                      flat
                                      placeholder="Holstein"
                                      outlined
                                      required
                                      :rules="breedRules"
                              ></v-autocomplete>
                            </v-col>
                            <!-- fin raza-->

                            <!-- inicio potrero-->
                            <v-col cols="12" class="d-flex flex-wrap py-2">
                              <div class="col-12 std-text-md std-text-blue-2 pa-0">Potrero</div>
                              <v-autocomplete
                                      v-model="animal.group"
                                      :items="groups"
                                      dense
                                      hide-details
                                      placeholder="Establo increíble"
                                      outlined
                                      :rules="paddockRules"
                                      required
                              ></v-autocomplete>
                            </v-col>
                            <!-- fin potrero-->

                            <!-- inicio id interno-->
                            <v-col cols="12" class="d-flex flex-wrap py-2">
                              <div class="col-12 std-text-md std-text-blue-2 pa-0">Identificador interno</div>
                              <v-text-field
                                      v-model="animal.idInternal"
                                      class="form-text-input"
                                      outlined
                                      dense
                                      hide-details
                                      placeholder="123"
                                      :rules="idRules">
                              </v-text-field>
                            </v-col>
                            <!-- fin id interno-->

                            <!-- inicio fecha nacimiento-->
                            <v-col cols="12" class="d-flex flex-wrap py-2">
                              <div class="col-12 std-text-md std-text-blue-2 pa-0">Fecha de nacimiento</div>
                              <v-menu
                                      v-model="birthdayPicker"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                          append-icon="mdi-calendar-blank"
                                          outlined
                                          :value="formattedBirthday"
                                          dense
                                          hide-details
                                          placeholder="DD/MM/AAAA"
                                          readonly
                                          required
                                          :rules="genericRules"
                                          v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                        :key="birthdayKey"
                                        v-model="animal.birthday"
                                        :allowed-dates="awdBirthday"
                                        @input="birthdayPicker = false"
                                        locale="es-419">
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <!-- inicio fecha nacimiento-->

                            <!-- input identificador siniiga -->
                            <v-col cols="12" >
                              <v-row no-gutters>
                                <v-col cols="12"
                                       class="d-flex flex-wrap"
                                       v-if="!heiferReproductiveFlag">
                                  <div class="col-12 std-text-md std-text-blue-2 pa-0">Identificador SINIIGA</div>
                                  <v-text-field
                                          v-model="animal.idSiniiga"
                                          prefix="MX-00-AGS(01)-"
                                          v-mask="'####-####'"
                                          placeholder="0000-0000"
                                          dense
                                          outlined
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                            <!-- fin de input identificador siniiga -->
                          </v-row>
                        </v-col>
                    </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-expansion-panels multiple accordion class="order-4 my-2 d-sm-none">
                  <v-expansion-panel>
                      <v-expansion-panel-header class="expansion-panel-background-color">
                          <b class="smart-title-2 home-title-container-mobile">Datos Reproductivos</b>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="expansion-panel-background-color">
                          <v-col cols="12" class="d-flex flex-wrap pa-0">
                            <v-row no-gutters>
                              <!-- input de ciclo de lactancia -->
                              <v-col cols="12" class="d-flex flex-wrap">
                                <div class="col-12 std-text-md std-text-blue-2 pa-0"
                                v-if="(animalType === 'heifer' && heiferReproductiveFlag) || animalType === 'cow'">
                                  Ciclo de lactancia
                                </div>
                                <!-- input de ciclo de lactancia -->
                                <v-select
                                        v-model="animal.lactationCycle"
                                        :items="lactationCycles"
                                        dense
                                        placeholder="0"
                                        v-if="(animalType === 'heifer' && heiferReproductiveFlag) || animalType === 'cow'"
                                        outlined
                                ></v-select>
                                <!-- fin de input de ciclo de lactancia -->
                              </v-col>
                              <!-- fin de input de ciclo de lactancia -->
                              <!-- input fecha de último parto -->
                              <v-col cols="12" class="d-flex flex-wrap"
                                     v-if="animalType === 'cow' && !(animal.lactationCycle === '' || animal.lactationCycle === 0)">
                                <div class="col-12 std-text-md std-text-blue-2 pa-0">
                                  Fecha de último parto</div>
                                <v-menu
                                        v-model="lastChildBirthPicker"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                            :value="formattedLastChildBirth"
                                            placeholder="DD/MM/AAAA"
                                            append-icon="mdi-calendar-blank"
                                            outlined
                                            dense
                                            readonly
                                            v-on="on">
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                          v-model="animal.lastChildBirth"
                                          no-title @input="lastChildBirthPicker = false"
                                          :allowed-dates="allowedLastChildBirthDates"
                                          locale="es-419"></v-date-picker>
                                </v-menu>
                              </v-col>
                              <!-- fin de fecha de último parto -->
                              <!-- input de etapa reproductiva -->
                              <v-col cols="12" class="d-flex flex-wrap"
                                     v-if="(animalType === 'heifer' && heiferReproductiveFlag) ||
                                     animalType === 'cow' && animal.lactationCycle !== ''">
                                <div class="col-12 std-text-md std-text-blue-2 pa-0">
                                  Etapa reproductiva</div>
                                <v-select
                                        v-model="reproductiveStage"
                                        :items="reproductiveEvents"
                                        dense
                                        placeholder="Gestante"
                                        :rules="genericRules"
                                        outlined
                                ></v-select>
                              </v-col>
                              <!-- fin de input de etapa reproductiva -->
                              <!-- input de fecha de etapa reproductiva -->
                              <v-col cols="12" class="d-flex flex-wrap"
                                     :class="[{'pl-2': animalType === 'heifer'}, {'pr-2': animalType === 'cow'}]"
                                     v-if="!(this.reproductiveStage === '' || this.reproductiveStage === 'Ninguno')">
                                <div class="col-12 std-text-md std-text-blue-2 pa-0">{{stageTitle}}</div>
                                <v-menu
                                        v-model="reproductiveStagePicker"
                                        v-if="!(this.reproductiveStage === '' || this.reproductiveStage === 'Ninguno')"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                            :value="formattedReproductiveStageDate"
                                            append-icon="mdi-calendar-blank"
                                            :rules="genericRules"
                                            outlined
                                            placeholder="DD/MM/AAAA"
                                            dense
                                            readonly
                                            v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                          v-model="reproductiveStageDate"
                                          no-title
                                          :allowed-dates="allowedReproductiveStagesDates"
                                          @input="reproductiveStagePicker = false"
                                          locale="es-419"></v-date-picker>
                                </v-menu>
                              </v-col>
                              <!-- fin de input de fecha de etapa reproductiva (vaquilla) -->

                              <!-- inicio datos de vaquilla -->
                              <v-col cols="12" v-if="animalType === 'heifer'">
                                <v-row no-gutters>
                                  <v-col cols="12" class="d-flex flex-wrap">
                                    <div class="col-12 std-text-md std-text-blue-2 pa-0">Vaca madre</div>
                                    <!-- input vaca madre -->
                                    <v-select
                                            v-model="animal.cowParent"
                                            :items="tempID"
                                            placeholder="123"
                                            dense
                                            outlined
                                    ></v-select>
                                    <!-- fin de input vaca madre -->
                                  </v-col>
                                  <v-col cols="12" class="d-flex flex-wrap">
                                    <div class="col-12 std-text-md std-text-blue-2 pa-0">Toro padre</div>
                                    <!-- input de toro padre -->
                                    <v-select
                                            v-model="animal.bullParent"
                                            :items="tempID"
                                            dense
                                            placeholder="123"
                                            outlined
                                    ></v-select>
                                    <!-- fin de input de toro padre -->
                                  </v-col>
                                  <v-col cols="12" class="d-flex flex-wrap">
                                    <div class="col-12 std-text-md std-text-blue-2 pa-0">Tamaño al nacer</div>
                                    <!-- input de peso al nacer -->
                                    <v-text-field
                                            v-model="animal.size"
                                            dense
                                            :rules="numberRules"
                                            placeholder="360"
                                            suffix="kg."
                                            outlined
                                    ></v-text-field>
                                    <!-- fin de input de peso al nacer -->
                                  </v-col>

                                  <v-col cols="12"
                                        v-if="animalType === 'heifer'"
                                        class="d-flex flex-wrap">
                                    <div class="col-12 std-text-md std-text-blue-2 pa-0">Peso al nacer</div>
                                    <!-- input de peso al nacer -->
                                    <v-text-field
                                            v-model="animal.weight"
                                            dense
                                            placeholder="1000"
                                            suffix="kgs"
                                            outlined
                                            :rules="numberRules"
                                            required
                                    ></v-text-field>
                                    <!-- fin de input de peso al nacer -->
                                  </v-col>
                                </v-row>
                              </v-col>
                              <!-- fin datos de vaquilla -->
                            </v-row>
                          </v-col>
                      </v-expansion-panel-content>
                  </v-expansion-panel>
              </v-expansion-panels>
              <!-- fin de paneles expansivos-->

              <!-- inicio de tercer bloque de inputs -->
              <v-col cols="12" class="order-5 pa-0 mt-4 sm-mt-0" >
                <v-row no-gutters justify="center">
                  <!-- inicio de campos de texto -->
                  <v-col cols="8" sm="3">
                    <v-btn block class="std-btn std-green-btn" @click="saveAnimal()">
                      Registrar {{ btnAnimal }}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <!-- fin de tercer bloque de inputs -->
              <!-- fin de segundo bloque de inputs -->
            </v-row>
            </v-form>
            <!-- fin de contenedor principal -->
          </v-col>
          <!-- fin de contenido principal -->
        </v-row>
      </v-col>

      <v-snackbar
          v-model="errorSnack"
          right
          color="#EB004E"
          :timeout="1500">
        Parece que te faltan algunos datos
        <template v-slot:action="{ attrs }">
          <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="errorSnack = false">
            Cerrar
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>
  </v-container>
</template>

<!--suppress ES6ShorthandObjectProperty, ES6ShorthandObjectProperty -->
<script>
    import moment from 'moment';
    import ChangeRanch  from "../components/ChangeRanch";
    import { EventBus } from './bus';
    import BackButton from "../components/BackButton";
    import getFormattedNumber from '../mixins/formatting';
    export default {
        name: 'CowForm',
      mixins: [getFormattedNumber],
        components:{
            BackButton,
            ChangeRanch,
        },
        computed: {
            /**
             * Obtiene los ranchos actuales en el sistema desde la store
             * para posteriormente pasarlo como prop al componente
             * changeRanch
             * @returns {getters.getPaddockSelected}
             */
            currentPaddocks() {
                return this.$store.getters.getPaddocks;
            },
            animalString() {
                switch (this.animalType) {
                    case 'heifer':
                        return '¡Guardando vaquilla!';
                    case 'cow':
                        return '¡Guardando vaca!';
                    case 'bull':
                        return '¡Guardando toro!';
                    default:
                        return null;
                }
            },
            /**
             * Regresa la fecha de la etapa reproductiva del animal en formato día - mes - año
             */
            formattedReproductiveStageDate() {
                return this.reproductiveStageDate ? moment(this.reproductiveStageDate).format('DD [de] MMMM [del] YYYY') : '';
            },
            /**
             * Regresa la fecha nacimiento del animal en formato día - mes - año
             */
            formattedBirthday() {
                return this.animal.birthday ? moment(this.animal.birthday).format('DD [de] MMMM [del] YYYY') : '';
            },

            /**
             * Regresa la fecha último parto del animal en formato día - mes - año
             */
            formattedLastChildBirth() {
                return this.animal.lastChildBirth ? moment(this.animal.lastChildBirth).format('DD [de] MMMM [del] YYYY') : '';
            },
            animalBirthday() {
                return this.animal.birthday;
            },
            animalLastChildBirth() {
                return this.animal.lastChildBirth;
            },
            animalIDSiniiga() {
                return this.animal.idSiniiga;
            },
            stageTitle() {
                switch (this.reproductiveStage) {
                    case 'PEV':
                        return 'Fecha de PEV';
                    case 'Inseminada':
                        return 'Fecha de inseminación';
                    case 'Gestante':
                        return 'Fecha de gestación';
                    case 'Aborto':
                        return 'Fecha de aborto';
                    default:
                        return '';
                }
            },
        },
        watch: {
            animalType(newType) {
                switch (newType) {
                    case 'heifer':
                        this.animal.lactationCycle = '0';
                        this.btnAnimal = 'vaquilla';
                        break;
                    case 'cow':
                      this.animal.lactationCycle = '1';
                      this.btnAnimal = 'vaca';
                        break;
                    case 'bull':
                        this.btnAnimal = 'toro';
                        break;
                    default:
                        break;
                }
            },
            animalBirthday(newDate) {
                this.getReproductiveEvents(newDate);
                this.getLactationCycles(newDate);
                // reinicia los demás campos involucrados
                this.animal.lactationCycle = '0';
                this.animal.lastChildBirth = null;
                this.reproductiveStage = '';
                this.reproductiveStageDate = null;
                // activa el tercer bloque de inputs si es vaquilla
                this.heiferReproductiveFlag = moment(newDate).add(360, 'd').isBefore(moment()) && this.animalType === 'heifer';
            },
            animalLastChildBirth(newDate) {
              if (newDate) {
                  this.getReproductiveEvents(newDate)
              }
            },
            reproductiveStage(newVal) {
                if (newVal === 'Ninguno' && this.animalType === 'cow') {
                    if (moment(this.animal.birthday).add(742, 'd').isAfter(moment()))
                    this.emptyLastChildBirth = true;
                } else {
                    this.emptyLastChildBirth = false;
                }
            }
        },
        data() {
            return {
                birthdayKey: 0,
              errorSnack: false,
                emptyLastChildBirth: false,
                animalType: 'cow', // tipo de animal seleccionado por el usuario
                paddockSelected: 'Seleccionar rancho', // rancho seleccionado
                reproductionValid: false,
                paddocks: [ // ranchos disponible, versión dummy << BORRAR CUANDO YA NO SEAN NECESARIOS >>
                    {
                        name: 'El Pariente',
                    },
                    {
                        name: 'El 100axo',
                    },
                    {
                        name: 'El Mochilas',
                    },
                ],
                cowSaved: false,
                // nuevo objeto animal
                lactationCycle: '0',
                animal: {
                    birthday: moment().subtract(742, 'd').format('YYYY-MM-DD'), // nacimiento
                    breed: null, // raza
                    firstBirthDatePassed: false, // indica si el animal ya pasó el primer parto
                    group: null, // grupo
                    smartbellCow: false, // indica si es un animal tipo Smartbell
                    history: {}, // bitácora
                    idInternal: null, // identificador interno
                    idSiniiga: null, // identificador siniiga
                    isInHeat: false, // estado de celo
                    isPregnant: false, // estado de preñado
                    milkState: '', // estado de lactancia
                    lactationCycle: '', // ciclo de lactancia
                    lastChildBirth: undefined, // último parto
                    lastHeatDate: '', // fecha de último celo
                    pregnantDate: '', // fecha de preñado
                    cowParent: null, // vaca madre
                    bullParent: null, // toro padre
                    size: null, // tamaño
                    weight: null, // peso
                },
                snackbar: false,
                dialog: false,
                reproductiveStage: '', // etapa reproductiva del animal, ...
                reproductiveStageDate: null, // fecha de la etapa reproductiva, ...
                reproductiveEvents: ['Ninguno'], // eventos  a seleccionar
                allowedFirstDate: '', // primera fecha permitida para un evento
                allowedPivotDate: '', // fecha a tomar en cuenta para los eventos
                groups: ['Establo general', 'Alta producción', 'Secas o en reto', 'Recién paridas', 'Enfermas'], // grupos personalizados
                breeds: ['Holstein', 'Jersey', 'Simmental', 'Pardo Suizo', 'Guernsev', 'Ayrshire', 'Shorthorn', 'Normando Francés', 'Otra raza'], // razas del animal
                tempID: ['1234', '231', '243', '123589'],
                lactationCycles: ['1'], // ciclos de lactancia del animal, ...
                birthdayPicker: false, // selector del calendario de fecha de nacimiento
                lastChildBirthPicker: false, // selector del calendario de último parto, ...
                reproductiveStagePicker: false, // selector del calendario de la etapa reproductiva, ...
                valid: false, // indica si la forma es válida o no
                // reglas para el input de ID
                idRules: [
                    v => !!v || 'Dato requerido',
                    v => /^[\w|\s]*$/.test(v) || 'Introduce sólo números y letras',
                ],
                sinRules: [
                    v => /^[A-Za-z0-9]*$/.test(v) || 'Asegúrate que sean sólo números y letras',
                ],
                // reglas para el input de fecha de nacimiento
                lastChildBirthRules: [
                    v => (moment().diff(moment(v)) > 1) || 'Aún no hay viajes en el tiempo',
                    v => (this.animal.birthday !== '' && moment(this.animal.birthday).isBefore(moment(v))) || 'Revisa la fecha de nacimiento',
                ],
                genericRules: [
                    v => !!v || 'Dato requerido',
                    v => (v.length > 0) || "Información no valida",
                ],
                paddockRules: [
                    v => /^[a-zA-Zá-úÁ-Ú]*(\s[a-zA-Zá-úÁ-Ú]*)*$/.test(v) || "Introduce sólo letras"
                ],
                breedRules: [
                    v => /^[a-zA-Zá-úÁ-Ú]*(\s[a-zA-Zá-úÁ-Ú]*)*$/.test(v) || "Introduce sólo letras"
                ],
                numberRules: [
                    v => (/^\d*\.?\d*$/.test(v) || v === null)|| 'Sólo números'
                ],
                lactationRules: [
                    v => !!v || 'Campo requerido',
                ],
                btnAnimal: 'vaca',
                birthdayDifference: undefined,
                heiferReproductiveFlag: false,
            };
        },
        methods: {
          back() {
            this.$router.go(-1);
          },
            save (date) {
                this.$refs.menu.save(date)
            },
           /**
             * Cambia el tipo del animal
             * @param newAnimalType
             */
            setAnimalType(newAnimalType) {
                if (this.animalType !== newAnimalType) {
                    this.animalType = newAnimalType;
                    this.resetAnimal();
                }
            },
            /**
             * Calcula las fechas permitidas para el picker date de la fecha de nacimiento de la vaca
             * @param val fecha a revisar mediante la fecha actual
             * @returns {boolean} true si la fecha es permitida, false si no es así
             */
            awdBirthday(val) {
                // mayor a 360 dias (12 meses) y no mayor a la fecha actual
                if (this.animalType === 'cow') {
                    return moment(val).isBefore(moment().subtract(742, 'd'));
                } else {
                    return moment(val).isBefore(moment());
                }
            },
            /**
             * Calcula las fechas permitidas para el picker date de la fecha de último parto
             * @param val la fecha a revisar mediante la fecha de nacimiento
             * @returns {boolean} true si la fecha es permitida, false si no es así
             */
            allowedLastChildBirthDates(val) {
                // mayor a 742 dias 360 + 389 y no mayor a la fecha actual
                return moment(val).diff(moment(this.animal.birthday), 'd') >= 742 && (moment().diff(moment(val)) > 1);
            },
            /**
             * Calcula las fechas permitidas para el picker date de la fecha de etapa reproductiva
             * @param val la fecha a revisar mediante la fecha de nacimiento
             * @returns {boolean} true si la fecha es permitida, false si no es así
             */
            allowedReproductiveStagesDates(val) {
                let today = moment();
                let pivotDate = moment(this.animal.birthday)
                // mayor a 18 días (primer celo) y no mayor a la fecha actual
                return moment(val).diff(moment(pivotDate), 'd') >= 18 && (today.diff(moment(val)) > 1);
            },
            /**
             * Obtiene los eventos reproductivos según la fecha de nacimiento o bien,
             * según la fecha de último parto si se trata de una vaca
             */
            getReproductiveEvents(date) {
                this.reproductiveEvents = [];
                this.reproductiveStage = '';
                let today = moment();
                if (this.animalType === 'heifer') {
                  today = today.subtract(360, 'd');
                }
                let pivotDate = moment(date);
                // 21 - 3 días para el primer celo
                if (pivotDate.add(18, 'd').isBefore(today)) {
                    this.reproductiveEvents.push('PEV');
                }
                // 70 - 3 días para recomendar la primera inseminación
                if (pivotDate.add(67, 'd').isBefore(today)) {
                    this.reproductiveEvents.push('Inseminada');
                }
                // 115 - 3 días para alcanzar la primera gestación a partir de la fecha de último parto
                if (pivotDate.add(112, 'd').isBefore(today)) {
                    this.reproductiveEvents.push('Gestante');
                    this.reproductiveEvents.push('Aborto');
                }
                this.reproductiveEvents.push('Ninguno');
            },
            /**
             * Obtiene los ciclos de lactancia según la fecha de nacimiento
             */
            getLactationCycles(birthday) {
                if (this.animalType === 'cow') {
                    this.lactationCycles = ['1'];
                    let diff = moment().diff(moment(birthday), 'd');
                    // 360 (13 meses) + 389 (primer ciclo ideal de parto)
                    let newLimit = 360 + 389;
                    let index = 2;
                    while (newLimit < diff) {
                        newLimit += 389;
                        this.lactationCycles.push(index.toString());
                        index++;
                    }
                } else {
                    this.lactationCycles = ['0'];
                }
            },
            /**
             * Borra todos los datos que el usuario ha introducido hasta el momento
             */
            resetAnimal() {
                this.animal = {
                    birthday: '', // nacimiento
                    breed: null, // raza
                    firstBirthDatePassed: false, // indica si el animal ya pasó el primer parto
                    group: null, // grupo
                    smartbellCow: false, // indica si es un animal tipo Smartbell
                    history: {}, // bitácora
                    idInternal: null, // identificador interno
                    idSiniiga: null, // identificador siniiga
                    heat: false, // estado de celo
                    isPregnant: false, // estado de preñado
                    milkState: '', // estado de lactancia
                    lactationCycle: '', // ciclo de lactancia
                    lastChildBirth: null, // último parto
                    lastHeatDate: '', // fecha de último celo
                    pregnantDate: '', // fecha de preñado
                    cowParent: null, // vaca madre
                    bullParent: null, // toro padre
                    size: null, // tamaño
                    weight: null, // peso
                }
                this.emptyLastChildBirth = false;
                this.heiferReproductiveFlag = false;
                switch (this.animalType) {
                    case 'cow':
                        console.log('byeee');
                        this.animal.birthday = moment().subtract(742, 'd').format('YYYY-MM-DD');
                        break;
                    default:
                        this.animal.birthday = moment().format('YYYY-MM-DD');
                        break;
                }
            },
            saveAnimal() {
                let reproductiveEvent = {};
                if (this.$refs.form.validate()) {
                  this.snackbar = true;
                  let formattedAnimal = null;
                    let payload = {
                        eventType: null,
                        animal: null,
                        event: null,
                        path: 'heifers',
                    }
                    switch (this.animalType) {
                        case 'heifer':
                            formattedAnimal = this.getFormattedAHeifer();
                            if (this.heiferReproductiveFlag) {
                                switch (this.reproductiveStage) {
                                    case 'PEV':
                                        reproductiveEvent = this.getHeatEvent(false);
                                        payload.eventType = 'heat';
                                        formattedAnimal.inHeat = this.getInHeatStatus(this.reproductiveStageDate);
                                      break;
                                    case 'Inseminada':
                                        reproductiveEvent = this.getHeatEvent(true);
                                        payload.eventType = 'heat';
                                      formattedAnimal.inHeat = this.getInHeatStatus(this.reproductiveStageDate);
                                      break;
                                    case 'Gestante':
                                        reproductiveEvent = this.getPregEvent();
                                        payload.eventType = 'preg';
                                      formattedAnimal.pregDate = this.getFormattedDate(this.reproductiveStageDate);
                                        formattedAnimal.inHeat = 'not_yet'
                                      break;
                                    case 'Aborto':
                                        formattedAnimal.calving.date = this.getFormattedDate(this.reproductiveStageDate);
                                        formattedAnimal.calving.abort = true;
                                        reproductiveEvent = this.getBirthEvent(false);
                                        payload.eventType = 'birth';
                                        formattedAnimal.inHeat = this.getInHeatStatus(this.reproductiveStageDate, false);
                                      break;
                                    case 'Ninguno':
                                        formattedAnimal.smartCow = false;
                                        formattedAnimal.inHeat = this.getInHeatStatus(this.animal.birthday, false);
                                      break;
                                      default:
                                        break;
                                }
                                payload.animal = formattedAnimal;
                                payload.event = reproductiveEvent;
                                this.$store.dispatch('saveAnimal', payload);
                            } else {
                                console.log("vaquilla sin evento reproductivo");
                                payload.animal = formattedAnimal;
                                this.$store.dispatch('saveAnimal', payload);
                            }
                            break;
                        case 'cow':
                          formattedAnimal = this.getFormattedCow();
                          switch (this.reproductiveStage) {
                                case 'PEV':
                                    reproductiveEvent = this.getHeatEvent(false);
                                  payload.eventType = 'heat';
                                  formattedAnimal.inHeat = this.getInHeatStatus(this.reproductiveStageDate);
                                    break;
                                case 'Inseminada':
                                    reproductiveEvent = this.getHeatEvent(true);
                                    formattedAnimal.inHeat = this.getInHeatStatus(this.reproductiveStageDate);
                                    payload.eventType = 'heat';
                                  break;
                                case 'Gestante':
                                    reproductiveEvent = this.getPregEvent();
                                  // noinspection JSValidateTypes
                                  payload.eventType = 'preg';
                                  formattedAnimal.pregDate = this.getFormattedDate(this.reproductiveStageDate);
                                    formattedAnimal.inHeat = 'not_yet'
                                  break;
                                case 'Aborto':
                                    // noinspection JSValidateTypes
                                    formattedAnimal.calving.date = this.getFormattedDate(this.reproductiveStageDate);
                                    formattedAnimal.calving.abort = true;
                                    reproductiveEvent = this.getBirthEvent(false);
                                    payload.eventType = 'birth';
                                    formattedAnimal.inHeat = this.getInHeatStatus(this.reproductiveStageDate, false);
                                  break;
                                case 'Ninguno':
                                    formattedAnimal.calving.date = this.getFormattedDate(this.animal.lastChildBirth);
                                    if (!formattedAnimal.calving.date) {
                                        formattedAnimal.smartCow = false;
                                        formattedAnimal.inHeat = this.getInHeatStatus(this.animal.birthday, false);
                                    } else {
                                      reproductiveEvent = this.getBirthEvent(true);
                                      payload.eventType = 'birth';
                                      formattedAnimal.inHeat = this.getInHeatStatus(formattedAnimal.calving.date, false);
                                    }
                                    break;
                                    default:
                                        break;
                            }
                            payload.animal = formattedAnimal;
                            payload.event = reproductiveEvent;
                            formattedAnimal.lastPregDate = this.getFormattedDate(this.getLastPregDate(this.animal.lastChildBirth));
                            payload.path = 'cows'
                            this.$store.dispatch('saveAnimal', payload);
                            break;
                        case 'bull':
                            payload.path = 'bulls'
                            payload.animal = this.getFormattedBull();
                            this.$store.dispatch('saveAnimal', payload);
                            break;
                        default:
                            break;

                    }
                } else {
                  this.errorSnack = true;
                }
            },
          getLastPregDate(date) {
              return date ? moment(this.animal.lastChildBirth).subtract(235, 'd') : null;
          },
          /**
           * Get the inHeat status for cows
           */
          getInHeatStatus(date, passed = true) {
            let heatDiff = moment().diff(moment(date), 'd');
            for (let i = 1; i < 7; i++) {
              let tmpPivot = i * 21;
              if (heatDiff >= tmpPivot - 3 && heatDiff <= tmpPivot + 3) {
                if (passed) {
                  return 'registered';
                } else {
                  return 'pending';
                }
              }
            }
            return 'not_yet';
          },
          /**
           * Get a heat object ready to be saved in the animal heats
           */
            getHeatEvent(wasInseminated) {
                return {
                    bull: null,
                    confirmed: true,
                    clean: false,
                    inseminated: wasInseminated,
                    heat: true,
                    waiting: !wasInseminated,
                    treatment: {
                        applied: false,
                        type: null,
                    },
                    date: moment().format('YYYY-MM-DD'),
                };
            },
          getPregEvent() {
              return {
                description: '¡Logramos que este animal estuviera gestante!',
                type: 1,
                isPregnant: true,
                name: 'Concepción exitosa',
                method: 'touch',
                date: this.reproductiveStageDate,
              }
          },
          getBirthEvent(type) {
              let tmpType = type ? 'Parto' : 'Aborto';
              return {
                description: 'Este animal tuvo un ' + tmpType.toLowerCase() + '.',
                type: 'birth',
                name: tmpType,
                date: this.reproductiveStageDate,
                sick: null,
                abortType: tmpType === 'Aborto' ? 'natural' : null,
                abortReason: tmpType === 'Aborto' ? 'otro' : null,
              }
          },
            /**
             * Get an object heifer ready to be saved in firestore
             * @returns an object that represents an animal
             */
            getFormattedAHeifer() {
                return {
                    breed: this.animal.breed,
                    idInternal: this.animal.idInternal,
                    group: this.animal.group,
                    birthday: this.animal.birthday,
                    cowParent: this.animal.cowParent,
                    bullParent: this.animal.bullParent,
                    size: !this.animal.weight ? this.animal.size : parseFloat(this.animal.size),
                    weight: !this.animal.weight ? this.animal.weight : parseFloat(this.animal.weight),
                    idSiniiga: this.animal.idSiniiga,
                    paddock: this.$store.getters.paddock.name,
                    smartAnimal: true,
                    health: {
                      sick: null,
                      key: null,
                    },
                    pregDate: null,
                    calving: {
                        date: null,
                        abort: false,
                    }
                }
            },
            /**
             * Get an object cow ready to be saved in firestore
             */
            getFormattedCow() {
                let cowObject = this.getFormattedAHeifer();
                cowObject.lactationCycle = this.animal.lactationCycle;
                cowObject.lastPregDate = null;
                cowObject.paddock = this.$store.getters.paddock.name;
              return cowObject;
            },
            /**
             * Get an object bull ready to be saved in firestore
             * @returns {{birthday: string, idInternal: null, breed: null, group: null, idSiniiga: null}}
             */
            getFormattedBull() {
                return {
                    breed: this.animal.breed,
                    idInternal: this.animal.idInternal,
                    group: this.animal.group,
                    birthday: this.animal.birthday,
                    idSiniiga: this.animal.idSiniiga,
                    paddock: this.$store.getters.paddock.name,
                }
            },
        },
        created() {
            moment.locale('es');
            EventBus.$on('hideSnack', (data) => {
                this.snackbar = data;
                this.resetAnimal();
                this.$refs.form.resetValidation();
            });
        },
        mounted() {

        }
    };
</script>

<style lang="css">
  @import '../style/CowForm.css';
  @import '../style/BaseStyle.css';
</style>
